// src/utils/Constantes.js
// DECLARACIÓN DE CONSTANTES PARA LA CONFIGURACIÓN DE RUTAS DE BACKEND, SE UTILIZA PARA FACILITAR EL CAMBIO ENTRE BACK LOCAL Y BACK DE PRUEBAS.
/*
    AYUDA PARA EL JR:
    PARA PRODUCTIVO:
    - esDesarrollo: false
    - esLocal: false

    PARA PRUEBAS:
    - esDesarrollo: true
    - esLocal: false

    PARA LOCAL:
    - esDesarrollo: true
    - esLocal: true
*/
const esDesarrollo = process.env.ES_DESARROLLO; //SI ES TRUE, APUNTA A BACK DE PRUEBAS, SI ES FALSE APUNTA A BACK DE PRODUCTIVO.
const esLocal = process.env.ES_LOCAL; //PRUEBAS LOCAL, APUNTA A BACK LOCAL, SI ES FALSE APUNTA A BACK DE PRUEBAS.

// RUTAS DE BACKEND PARA PRUEBAS, LOCAL Y PRODUCCIÓN(PENDIENTE).
const backPruebas = process.env.URL_PRUEBA;
const backLocal = process.env.URL_LOCAL;
const backProduccion = process.env.REACT_APP_API_URL;

// CENTRALIZAMOS EL TITULO DE LA APLICACIÓN EN UNA CONSTANTE PARA FACILITAR SU CAMBIO Y MANTENER LA CONSISTENCIA EN TODA LA APLICACIÓN.
const tituloOriginal = 'CAPACITACION & UNIVERSIDAD MADERAS - CIUDAD MADERAS';
// MARCAMOS EL AMBIENTE EN EL TITULO DE LA APLICACIÓN PARA FACILITAR LA IDENTIFICACIÓN DEL AMBIENTE EN EL QUE SE ESTÁ TRABAJANDO, ESPECIALMENTE EN PRUEBAS Y LOCAL.
const tituloApp = (esDesarrollo ? (esLocal ? '(PRUEBAS LOCAL)-' : '(PRUEBAS)-') : '') + '' + tituloOriginal;

export default {
    esDesarrollo,
    esLocal,
    tituloApp,
    // SI esLocal ES TRUE, APUNTAMOS AL BACK LOCAL, SINO AL BACK DE PRUEBAS.
    raiz: esLocal ? backLocal : esDesarrollo ? backPruebas : backProduccion,
    raizBack: esLocal ? backLocal : esDesarrollo ? backPruebas : backProduccion
};
